import { render } from "./BillToAddressCard.vue?vue&type=template&id=18cb927a&ts=true"
import script from "./BillToAddressCard.vue?vue&type=script&lang=ts"
export * from "./BillToAddressCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__